import { getTheme } from '@Thread-Magic/jasmine';
import { theme } from 'antd';

export default function antdCustomTheme(themeMode) {
  const isDarkMode = themeMode === 'dark';
  const algorithm = isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm;
  const tooltipBg = isDarkMode ? 'rgba(25, 45, 85, 0.8)' : 'rgba(3, 21, 60, 0.8)';

  return {
    colorPrimary: getTheme(themeMode).colors.brand.light.base,
    algorithm,
    components: {
      Input: {
        colorPrimary: getTheme(themeMode).colors.brand.light.base,
        colorLink: getTheme(themeMode).colors.brand.light.base,
        hoverBorderColor: getTheme(themeMode).colors.brand.light.base,
        activeBorderColor: getTheme(themeMode).colors.brand.light.base,
        colorTextPlaceholder: getTheme(themeMode).colors.gray5
      },
      Button: {
        colorPrimary: getTheme(themeMode).colors.brand.light.base,
        colorLink: getTheme(themeMode).colors.brand.light.base,
        textTextColor: getTheme(themeMode).colors.text.variant3,
        textTextHoverColor: getTheme(themeMode).colors.text.variant3,
        textTextActiveColor: getTheme(themeMode).colors.text.variant3,
        primaryShadow: 'none',
        fontWeight: 600,
        paddingBlockSM: 12,
        contentFontSizeSM: 12,
        algorithm: true
      },
      DatePicker: {
        colorPrimary: getTheme(themeMode).colors.brand.light.base,
        colorLink: getTheme(themeMode).colors.brand.light.base,
        algorithm: true
      },
      Select: {
        colorPrimary: getTheme().colors.brand.light.base,
        colorBgContainer: isDarkMode ? '#26292B' : '#fff',
        selectorBg: isDarkMode ? '#26292B' : '#fff',
        optionSelectedBg: isDarkMode ? '#4C5155' : '#fff',
        algorithm: true
      },
      InputNumber: {
        activeBorderColor: getTheme(themeMode).colors.brand.light.base,
        activeShadow: 'none'
      },
      Tooltip: {
        colorBgSpotlight: tooltipBg,
        padding: '6px 8px',
        borderRadius: 4,
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
        fontSize: 13,
        lineHeight: 1.5,
        fontWeight: 400,
        colorTextLightSolid: getTheme().colors.common.white,
        algorithm: true
      },
      Dropdown: {
        borderRadiusLG: 4,
        colorBgElevated: isDarkMode ? '#26292B' : '#fff'
      }
    }
  };
}
